import { useState } from "react";
import "./styles.css";

export default function Plain({ link, img, children }) {
  return (
    <a href={link}>
      <div className="container1">
        <div className="pic">
          <img width="300px" height="180px" src={img} alt="App" />
        </div>
        {children}
      </div>
    </a>
  );
}
